module.exports = __webpack_public_path__ + "img/2.60302f09.png";